import p from "./index216.mjs";
import h from "./index215.mjs";
import d from "./index426.mjs";
import g from "./index454.mjs";
import x from "./index453.mjs";
import b from "./index246.mjs";
import _ from "./index245.mjs";
import k from "./index427.mjs";
import s from "./index244.mjs";
const y = ["breakpoints", "palette", "spacing", "shape"];
function P(r = {}, ...i) {
  const {
    breakpoints: a = {},
    palette: m = {},
    spacing: c,
    shape: l = {}
  } = r, t = h(r, y), u = d(a), f = x(c);
  let e = s({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: p({
      mode: "light"
    }, m),
    spacing: f,
    shape: p({}, g, l)
  }, t);
  return e.applyStyles = k, e = i.reduce((n, o) => s(n, o), e), e.unstable_sxConfig = p({}, _, t == null ? void 0 : t.unstable_sxConfig), e.unstable_sx = function(o) {
    return b({
      sx: o,
      theme: this
    });
  }, e;
}
export {
  P as default
};
